module.exports = __webpack_public_path__ + "static/media/02.59c18b37.png";